import axios from "axios";
import { ApiConfig as CONFIG_API, CHARGEBEE, AppConfig } from "config/config";
import { REST, Args, Models } from 'fluent-forever-shared-types'
import { IHttpRequest } from "application/utils";

const chargebeeInstance = Chargebee.init({ site: CHARGEBEE.site });
chargebeeInstance.setPortalSession(async () => {
	const body: Args.ICreatePortalSessionArg = { callbackPath: AppConfig.PATH }
	const rst = await axios.post(CONFIG_API.url + REST.PATH.SUBSCRIPTION_PORTAL_CREATE, body);
	return rst.data;
});
const portalInstance = chargebeeInstance.createChargebeePortal();

const sections = {
	"SUBSCRIPTION_DETAILS": "sub_details",
	"SUBSCRIPTION_CANCELLATION": "sub_cancel",
	"EDIT_SUBSCRIPTION": "edit_subscription",
	"VIEW_SCHEDULED_CHANGES": "scheduled_changes",
	"ACCOUNT_DETAILS": "account_details",
	"EDIT_ACCOUNT_DETAILS": "portal_edit_account",
	"ADDRESS": "portal_address",
	"EDIT_BILLING_ADDRESS": "portal_edit_billing_address",
	"EDIT_SHIPPING_ADDRESS": "portal_edit_shipping_address",
	"EDIT_SUBSCRIPTION_CUSTOM_FIELDS": "portal_edit_subscription_cf",
	"PAYMENT_SOURCES": "portal_payment_methods",
	"ADD_PAYMENT_SOURCE": "portal_add_payment_method",
	"EDIT_PAYMENT_SOURCE": "portal_edit_payment_method",
	"VIEW_PAYMENT_SOURCE": "portal_view_payment_method",
	"CHOOSE_PAYMENT_METHOD_FOR_SUBSCRIPTION": "portal_choose_payment_method",
	"BILLING_HISTORY": "portal_billing_history"
}

export enum CheckoutStep {
	cart_screen = "cart_screen",
	review_screen = "review_screen",
	thankyou_screen = "thankyou_screen",

	//account info
	add_account_info = "add_account_info",
	edit_account_info = "edit_account_info",

	//billing address
	add_billing_address = "add_billing_address",
	edit_billing_address = "edit_billing_address",

	//payment_method
	add_payment_method = "add_payment_method",
	edit_payment_method = "edit_payment_method",


}

export interface ISubscriptionOptions {
	planId: string;
	request: IHttpRequest;
	onStepStarted?: (step: CheckoutStep) => void
	onStepCompleted?: (step: CheckoutStep) => void
}

class Subscription {
	/** Subscribe current user into plan */
	subscribe = (options: ISubscriptionOptions) => {
		return new Promise<Models.IPlanSubscriptionResult>((resolve, reject) => {
			let prevStep;
			const { planId, request } = options;
			chargebeeInstance.openCheckout({
				success: (hostedPageId: string) => {
					//Subscription Was Created in chargebee => Retrieve Info on Backed
					//ToDo: move this portion to API and inject callback into subscribe
					request.post(CONFIG_API.url + REST.PATH.SUBSCRIPTION_ON_CREATED, { hostedPageId })
						.then(result => {
							chargebeeInstance.closeAll();
							return resolve(result.data as Models.IPlanSubscriptionResult)
						})
						.catch(err => reject(err));
				},
				loaded: () => {
					console.debug("Checkout Loaded");
				},
				error: (error) => {
					console.debug("Checkout Failed");
					reject(error);
				},
				close: () => {
					// this.setState({ loading: false });
					console.debug("Checkout Closed");
				},
				step(step: any) {
					if (prevStep !== step) {
						if (prevStep && options.onStepCompleted) {
							options.onStepCompleted(prevStep);
						}
						if (options.onStepStarted) {
							options.onStepStarted(step);
						}
						prevStep = step;
						console.debug("Checkout Step:", step);
					}
				},
				hostedPage: () => {
					//ToDo: move this portion to API and inject callback into subscribe
					const body: Args.IStartNewSubscriptionCheckoutArg = { planId };
					return request.post(CONFIG_API.url + REST.PATH.SUBSCRIPTION_START, body)
						.then((response) => {
							return response.data.hosted_page;
						})
						.catch((err) => {
							console.error(err);
							reject(err);
							throw err;
						})
				}
			});
		});
	}

	/** Create subscription From Backer Code */
	createBackerSubscription = (arg: Args.ICreateBackerSubscriptionArg) => {
		axios.post(CONFIG_API.url + REST.PATH.SUBSCRIPTION_CREATE_BACKER_PLAN, arg)
			.then(result => {
				console.debug(result);
			})
	}

	portalOpen = async () => {
		portalInstance.open({
			close: () => {
				console.debug('Closing portal');
			}
		});
	}

	openSubscription = (subscriptionId) => {
		portalInstance.openSection({
			sectionType: sections.SUBSCRIPTION_DETAILS,
			params: { subscriptionId }
		});
	}

	openAccountDetails = () => {
		portalInstance.openSection({
			sectionType: sections.ACCOUNT_DETAILS
		});
	}

	openBillingInvoices = () => {
		portalInstance.openSection({
			sectionType: sections.BILLING_HISTORY
		});
	}

	openAddresses = () => {
		portalInstance.openSection({
			sectionType: sections.ADDRESS,
		});
	}

	openPaymentSources = () => {
		portalInstance.openSection({
			sectionType: sections.PAYMENT_SOURCES,
		});
	}
}

export const ChargeBee = new Subscription();



// WEBPACK FOOTER //
// ./src/api/ChargeBee.ts